import React, { useState } from 'react';
import { Button } from '@mui/material';
import { Cached } from '@mui/icons-material';

const ClearCacheButton = () => {
  const [loading, setLoading] = useState(false);

  const clearAllCaches = async () => {
    if (!window.confirm('Clear all caches and reload the system? This will refresh the page.')) {
      return;
    }

    setLoading(true);

    try {
      // Call backend to clear server cache
      const backendResponse = await fetch('/api/clear-cache', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (!backendResponse.ok) {
        throw new Error(`Backend cache clear failed: ${backendResponse.status}`);
      }

      const backendResult = await backendResponse.json();
      console.log('✅ Backend cache cleared:', backendResult);

      // Clear browser caches
      if ('caches' in window) {
        const cacheNames = await caches.keys();
        await Promise.all(
          cacheNames.map(cacheName => caches.delete(cacheName))
        );
      }

      // Clear session storage
      sessionStorage.clear();
      
      // ============ PRESERVE ALL USER DATA ============
      // Save all user-related data before clearing
      const userToken = localStorage.getItem('erp_auth_token');
      const userRole = localStorage.getItem('erp_user_role');
      const userName = localStorage.getItem('erp_username');
      const userEmail = localStorage.getItem('erp_user_email');
      const userId = localStorage.getItem('erp_user_id');
      const userSettings = localStorage.getItem('userSettings');
      const userData = localStorage.getItem('erp_user');
      
      // Clear all localStorage
      localStorage.clear();
      
      // Restore ALL user data
      if (userToken) localStorage.setItem('erp_auth_token', userToken);
      if (userRole) localStorage.setItem('erp_user_role', userRole);
      if (userName) localStorage.setItem('erp_username', userName);
      if (userEmail) localStorage.setItem('erp_user_email', userEmail);
      if (userId) localStorage.setItem('erp_user_id', userId);
      if (userSettings) localStorage.setItem('userSettings', userSettings);
      if (userData) localStorage.setItem('erp_user', userData);
      
      console.log('✅ Storage cleared (all user data preserved)');
      console.log('👤 Restored role:', userRole);

      // Reload page
      setTimeout(() => {
        window.location.reload(true);
      }, 1000);

    } catch (error) {
      console.error('❌ Error:', error);
      alert('Error clearing caches: ' + error.message);
      setLoading(false);
    }
  };

  return (
    <Button
      variant="contained"
      color="warning"
      startIcon={<Cached />}
      onClick={clearAllCaches}
      disabled={loading}
      size="small"
      sx={{
        borderRadius: 2,
        textTransform: 'none',
        fontWeight: 600,
        ml: 2,
        backgroundColor: loading ? '#ccc' : '#ed6c02',
        '&:hover': {
          backgroundColor: loading ? '#ccc' : '#db6d00'
        }
      }}
    >
      {loading ? 'Clearing...' : 'Clear Cache'}
    </Button>
  );
};

export default ClearCacheButton;